export default {
  component: {
    jobAdList: {
      title: '空缺職位',
      jobs: '工作',
      noJobAds: '目前沒有空缺職位。',
    },

    jobAdCard: {
      openUntil: date => `職位開放截至 ${date}`,
    },

    jobAdGreetings: {
      thankYou: '謝謝。',
      readyInfo: '您的申請現已收到，招聘人員將很快與您聯繫。',
      luck: '祝您好運！',
    },

    jobAdSeeYou: {
      title: '謝謝。',
      description: '您的申請已儲存，我們已傳送連結供您稍後繼續完成申請。',
    },

    unpublished: {
      title: '尚未發佈',
      info: '尚未發佈招聘廣告。',
    },
  },
}
